import { render, staticRenderFns } from "./CustomerUsingCoupon.vue?vue&type=template&id=2d0c1966&"
import script from "./CustomerUsingCoupon.vue?vue&type=script&lang=js&"
export * from "./CustomerUsingCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports